export default "__VITE_ASSET__D_81hP9y__"